/**
 * @file hooks/useWorkbench.ts
 * @description 四个角色工作台 dashboard 的 TanStack Query hooks。
 * 统一约定：apiClient.get 已在内部剥离响应 envelope（return data.data），
 * 故泛型直接为聚合数据类型 T，消费方拿到的 query.data 即为 T 本身，不需再 `.data`。
 */

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import type {
  AdminDashboardData,
  ManagerDashboardData,
  DeciderDashboardData,
  AuditorDashboardData,
} from '@zhcb/shared';

/** Admin 工作台聚合数据 */
export function useAdminDashboard() {
  return useQuery<AdminDashboardData>({
    queryKey: ['dashboard', 'admin'],
    queryFn: () => apiClient.get<AdminDashboardData>('/api/dashboard/admin'),
    refetchInterval: 60_000,
  });
}

/** Manager 工作台聚合数据 */
export function useManagerDashboard() {
  return useQuery<ManagerDashboardData>({
    queryKey: ['dashboard', 'manager'],
    queryFn: () => apiClient.get<ManagerDashboardData>('/api/dashboard/manager'),
    refetchInterval: 60_000,
  });
}

/** Decider 工作台聚合数据 */
export function useDeciderDashboard() {
  return useQuery<DeciderDashboardData>({
    queryKey: ['dashboard', 'decider'],
    queryFn: () => apiClient.get<DeciderDashboardData>('/api/dashboard/decider'),
    refetchInterval: 60_000,
  });
}

/** Auditor 工作台聚合数据 */
export function useAuditorDashboard() {
  return useQuery<AuditorDashboardData>({
    queryKey: ['dashboard', 'auditor'],
    queryFn: () => apiClient.get<AuditorDashboardData>('/api/dashboard/auditor/workbench'),
    refetchInterval: 60_000,
  });
}
